import {Button, Div, Label} from 'components';
import {Ecolors} from 'constant';
import React, {useState} from 'react';
import {navigate} from 'services';
import {apiEvent} from 'services/apis/apiEvent';
import {useAppSelector} from 'store/hooks';
import {convertPercent} from 'utils';

const Item = (p: {data: any; onPress: (t: any) => void}) => {
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const {
    name,
    id,
    color,
    tradingDayOfNavCurrently,
    valuationdate,
    navPercent,
    navCurrently,
    nameEn,
  } = p.data;

  return (
    <Button
      isScale={false}
      onPress={() => {
        p.onPress(p.data);
      }}
      paddingVertical={16}
      paddingHorizontal={21}
      minHeight={100}
      borderColor={Ecolors.bordercolor}
      borderWidth={0.8}
      borderRadius={8}
      backgroundColor={Ecolors.whiteColor}>
      <Label multilanguage={false} fontWeight={'700'}>
        {name}
      </Label>
      <Div
        paddingTop={10}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}>
        <Div>
          <Label size={14}>{`investmentscreen.thaydoisovoidaunam`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}>
            <Label size={14}>{`investmentscreen.denngay`}</Label>
            <Label multilanguage={false}>{` ${
              valuationdate || tradingDayOfNavCurrently || ''
            }`}</Label>
          </Div>
        </Div>
        <Div>
          <Label
            multilanguage={false}
            color={
              navPercent && navPercent < 0
                ? Ecolors.redColor
                : Ecolors.greenColor
            }
            size={18}
            fontWeight={'700'}>
            {navPercent >= 0 && '+'}
            {`${convertPercent(navPercent)}`}
          </Label>
        </Div>
      </Div>
    </Button>
  );
};

function ListSuggestInvest() {
  const [data, setData] = useState<Array<any>>([]);
  const walletBounty = useAppSelector(state => state.asset.walletBounty);
  const {totalInvitedUserAdaptEvent, remainBounty} = walletBounty;

  React.useEffect(() => {
    getData();
    return () => {};
  }, []);

  const getData = async () => {
    try {
      const res = await apiEvent.loadActiveList();
      if (res.status == 200) {
        setData(res.data);
      }
    } catch (error) {
    } finally {
    }
  };

  if (!remainBounty) {
    return <></>;
  }
  return (
    <Div
      marginTop={16}
      backgroundColor={'#E9EAEF'}
      paddingVertical={21}
      paddingHorizontal={16}>
      <Label
        marginLeft={6}
        marginBottom={16}
        fontWeight="bold">{`eventreward.dautuvoitienthuong`}</Label>
      {data?.map((item: any, index: number) => {
        return (
          <Div key={index} marginBottom={16}>
            <Item
              onPress={t => {
                navigate('CreateOrderBuyBountyScreen', {
                  initData: {
                    product: t,
                    listProduct: data,
                    scheme: t.productPrograms?.[0],
                  },
                });
              }}
              data={item}
            />
          </Div>
        );
      })}
    </Div>
  );
}
export default React.memo(ListSuggestInvest);
